module.exports = __webpack_public_path__ + "static/media/linkedin.9b24c856.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/linkedin.svg
 ** module id = 145
 ** module chunks = 0
 **/